import { createReducer, createTypes } from 'reduxsauce';

export const notificationsTypes = createTypes(
  `
  SAGA_SET_NOTIFICATION
  SET_NOTIFICATION
  SET_NOTIFICATION_AMOUNT
  SET_STATUS
  ADD_NOTIFICATION
  `,
  { prefix: 'NOTIFICATION/' }
);

const INITIAL_STATE = {
  notifications: [],
  amount: 0,
};

// Reducers
const setNotification = (state, action) => {
  return {
    ...state,
    notifications: action.notifications,
    amountDeleted: 20,
    amountArchived: 20,
  };
};

const setNotificationAmount = (state, action) => {
  return {
    ...state,
    amount: action.amount,
  };
};

const addNotification = (state, action) => {
  return {
    ...state,
    notifications: [action.newNotification, ...state.notifications],
  };
};

const setStatus = (state, action) => {
  return {
    ...state,
    status: action.status,
  };
};

export default createReducer(INITIAL_STATE, {
  [notificationsTypes.SET_NOTIFICATION]: setNotification,
  [notificationsTypes.ADD_NOTIFICATION]: addNotification,
  [notificationsTypes.SET_STATUS]: setStatus,
  [notificationsTypes.SET_NOTIFICATION_AMOUNT]: setNotificationAmount,
});
